// tslint:disable
export var SubIdType;
(function (SubIdType) {
    // PLP Claim Id
    SubIdType[SubIdType["PLPClaim"] = 1] = "PLPClaim";
})(SubIdType || (SubIdType = {}));
SubIdType['PLPCLAIM'] = 1;
//# sourceMappingURL=SubIdType.js.map